<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <div v-for="(carteAffaire, index) in sas.employeurs.filter((x) => x.nomEmployeur)" :key="carteAffaire.id">
        <h3 class="mb-3">{{ carteAffaire.nomEmployeur }}</h3>
        <data-iterator
          :list="superviseurs[index]"
          add-new-text="Ajouter un superviseur"
          :live="{ endpoint: 'sas-superviseurs', sasId: sas.id, payload: { carteAffaire: carteAffaire.id } }"
          :icon="$getIcon('teacher')"
          :valids="validsParCarte[index]"
          :ref="`dataIterator_${index}`"
        >
          <template v-slot:show-mode="{ item }">
            <h3 class="mb-3">{{ superviseurTitle(item) }}</h3>
          </template>
          <template v-slot:edit-mode="{ item }">
            <template v-if="item.numeroPermis">
              <h3 class="mb-3">{{ superviseurTitle(item) }}</h3>
              <opq-file code="attestation_superviseur" :file="item.attestation" :live="liveSasSuperviseurs(24008, item)"></opq-file>
            </template>
            <template v-else>
              <search-numero-permis @contact-selected="contactSelected($event, item)"></search-numero-permis>
              <v-checkbox
                class="list_counter_validator my-2 ml p-0"
                :input-value="item.numeroPermis"
                :rules="[(v) => !!v || 'Veuillez sélectionner un superviseur par numéro de permis.']"
              ></v-checkbox>
            </template>
          </template>
        </data-iterator>
        <v-divider class="my-3"></v-divider>
      </div>
    </v-form>
  </div>
</template>

<script>
import SearchNumeroPermis from "../Common/SearchNumeroPermis.vue"
import { Queue, Api } from "@/plugins/api"

export default {
  props: {
    sas: { type: Object, required: true }
  },
  data() {
    return {
      validsParCarte: [],
      superviseurs: [],
      valid: false
    }
  },
  created() {
    this.superviseurs = this.sas.employeurs.map((x) => this.sas.superviseurs.filter((s) => s.carteAffaire === x.id))
    this.validsParCarte = this.superviseurs.map((x) => x.map(() => true))
  },
  mounted() {
    this.$emit("validation-changed", this.isValid)
  },
  components: { SearchNumeroPermis },
  watch: {
    isValid() {
      this.$emit("validation-changed", this.isValid)
    },
    "sas.employeurs"() {
      this.superviseurs = this.sas.employeurs.map((x) => this.sas.superviseurs.filter((s) => s.carteAffaire === x.id))
    }
  },
  computed: {
    isValid() {
      return this.valid && this.validsParCarte.every((x) => x.every((b) => b))
    }
  },

  methods: {
    liveSasSuperviseurs(cle, item) {
      return { endpoint: "sas-superviseurs", cle: cle, fileId: item.id }
    },
    superviseurTitle(item) {
      return item.numeroPermis ? `${item.prenom} ${item.nom} (${item.numeroPermis})` : "Veuillez renseigner votre superviseur"
    },
    contactSelected(contact, superviseur) {
      Queue.enqueue(() =>
        Api.post("sas-superviseurs", {
          fileId: superviseur.id,
          cle: "24003",
          value: contact.id
        }).then(() => {
          superviseur.contactId = contact.id
          superviseur.nom = contact.nom
          superviseur.prenom = contact.prenom
          superviseur.numeroPermis = contact.numeroPermis
        })
      )
    }
  }
}
</script>